/**
 * BCV Converter — muestra el equivalente en bolívares (tasa BCV) junto a los
 * precios en USD de tu tienda Shopify, actualizando la tasa una vez al día.
 *
 * Ver la guía de instalación completa en el PDF "Guía BCV Converter".
 */
(function () {
  "use strict";

  // ---------- CONFIGURACIÓN ----------
  // Selectores donde el tema muestra precios en USD/EUR.
  // Ajustado a las clases reales de este tema (confirmadas por inspección):
  // div.price__container > div.price__sale / div.price__regular
  var PRICE_SELECTORS = [
    ".price__sale",
    ".price__regular",
  ];

  // API pública y gratuita con la tasa oficial BCV en JSON.
  var BCV_API_URL = "https://bcv.today/api/v1/rate.json";

  // Cuántas horas se mantiene la tasa en caché antes de volver a consultarla.
  var CACHE_HOURS = 12;
  var CACHE_KEY = "bcv_rate_cache_v1";

  // ---------- LÓGICA ----------
  function getCachedRate() {
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      var ageHours = (Date.now() - data.timestamp) / 1000 / 3600;
      if (ageHours > CACHE_HOURS) return null;
      return data.rate;
    } catch (e) {
      return null;
    }
  }

  function setCachedRate(rate) {
    try {
      localStorage.setItem(
        CACHE_KEY,
        JSON.stringify({ rate: rate, timestamp: Date.now() })
      );
    } catch (e) {
      /* localStorage no disponible, seguimos sin caché */
    }
  }

  function fetchBcvRate() {
    var cached = getCachedRate();
    if (cached) return Promise.resolve(cached);

    return fetch(BCV_API_URL)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        // bcv.today devuelve { "USD": 500.4606, "EUR": ..., "updated_at": ... }
        var rate = data && data.USD ? parseFloat(data.USD) : null;
        if (rate) setCachedRate(rate);
        return rate;
      })
      .catch(function () {
        return null;
      });
  }

  function parseUsdAmount(text) {
    // Extrae el número de un texto tipo "$25.00", "Precio habitual $25.00", etc.
    var match = text.replace(/,/g, "").match(/[\d]+(\.\d+)?/);
    return match ? parseFloat(match[0]) : null;
  }

  function formatBs(amount) {
    return (
      "Bs. " +
      amount.toLocaleString("es-VE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
  }

  function injectBsPrice(el, rate) {
    if (!el || el.dataset.bcvDone === "1") return; // evitar duplicados
    var usd = parseUsdAmount(el.textContent);
    if (!usd) return;

    var bsAmount = usd * rate;
    var bsSpan = document.createElement("span");
    bsSpan.className = "bcv-price";
    bsSpan.style.display = "block";
    bsSpan.style.flexBasis = "100%"; // fuerza salto de línea dentro de contenedores flex
    bsSpan.style.fontSize = "0.85em";
    bsSpan.style.fontWeight = "bold";
    bsSpan.style.color = "#e02020";
    bsSpan.style.marginTop = "4px";
    bsSpan.textContent = formatBs(bsAmount) + " (tasa BCV)";

    el.appendChild(bsSpan);
    el.dataset.bcvDone = "1";
  }

  function applyToPage(rate) {
    if (!rate) return;
    PRICE_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        injectBsPrice(el, rate);
      });
    });
  }

  function init() {
    fetchBcvRate().then(function (rate) {
      if (!rate) return; // si la API falla, no se muestra nada (no rompe la tienda)
      applyToPage(rate);

      // Reaplica cuando el DOM cambia (ej: al abrir el carrito, cambiar variante)
      var observer = new MutationObserver(function () {
        applyToPage(rate);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();